/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Signals_Geo_Detail_NoteInputs */

const en_directory_detail_signals_geo_detail_note = /** @type {(inputs: Directory_Detail_Signals_Geo_Detail_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generative Engine Optimization — how readily ChatGPT, Perplexity, Claude, and AI Overviews can crawl, parse, and cite this page. Scores come from replayable HTTP audits of the product's site.`)
};

const zh_directory_detail_signals_geo_detail_note = /** @type {(inputs: Directory_Detail_Signals_Geo_Detail_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GEO（生成式引擎优化）——ChatGPT、Perplexity、Claude 与 AI Overviews 抓取、解析并引用本页的难易度。分数来自可复放的产品站点 HTTP 审计。`)
};

/**
* | output |
* | --- |
* | "Generative Engine Optimization — how readily ChatGPT, Perplexity, Claude, and AI Overviews can crawl, parse, and cite this page. Scores come from replayable ..." |
*
* @param {Directory_Detail_Signals_Geo_Detail_NoteInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_signals_geo_detail_note = /** @type {((inputs?: Directory_Detail_Signals_Geo_Detail_NoteInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Signals_Geo_Detail_NoteInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_signals_geo_detail_note(inputs)
	return zh_directory_detail_signals_geo_detail_note(inputs)
});
export { directory_detail_signals_geo_detail_note as "directory.detail.signals.geo_detail_note" }